import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

const WRITE_ATTRIBUTES = ['bucket', 'key'];

export default class TaskAttachmentSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    // @ts-expect-error - we have no typings for the json api
    data.data.attributes = pick(data.data.attributes, WRITE_ATTRIBUTES);

    if (snapshot.id) {
      // @ts-expect-error - we have no typings for the json api
      delete data.data.relationships;
    } else {
      const taskChecklistItemId = snapshot.attr('taskChecklistItemId');

      // @ts-expect-error - we have no typings for the json api
      data.data.relationships = {
        task: { data: { id: snapshot.attr('taskId') } },
        ...(taskChecklistItemId && {
          task_checklist_item: { data: { id: taskChecklistItemId } },
        }),
      };
    }

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'task-attachment': TaskAttachmentSerializer;
  }
}
